<template>
  <div class="static storage">
	<div class="logo-left">
	  <a href="/storesafe" target="_parent">
		<img src="@/assets/images/storesafe-logo.png" width="100%" alt="StoreSafe logo" />
	  </a>
	</div>
	<h1>{{ $t('storage.page_title') }}</h1>
  </div>

  	<div class="static-grey">
	  {{ $t('storage.intro_text') }}
	</div>
	<div class="static-white">
	  <div class="static-split">
		  <div class="split-image">
			<img src="@/assets/images/storage_camshelving.jpg" alt="Camshelving">
		  </div>
		  <div class="split-content">
			<h2>{{ $t('storage.camshelving_elements_xtra_series_premium') }}</h2>
			<p>{{ $t('storage.designed_with_food_safety_in_mind_camshe') }}</p>
			<a href="https://www.cambro.com/Products/shelving/ " target="_blank" class="learn-more">
			<button @mouseover="isHovered = true"
					@mouseleave="isHovered = false"
					:class="{ 'hovered': isHovered }">
			  {{ $t('receiving.learn_more_btn')}}
			</button></a>
		  </div>
	   </div>
	   
	   <div class="static-testimonial">
		   <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		   <div class="testimonial-quote">{{ $t('storage.before_i_used_wire_shelving_like_everyon') }}&quot;</div>
		   <div class="testimonial-pic"><img src="@/assets/images/storage_testimonial-matt-bickford.jpg" /></div>
		   <div class="testimonial-name"><a href="https://blog.cambro.com/2024/02/20/stop-ruining-your-food-storage-with-metal-shelving/" target="_blank">{{ $t('storage.matt_bickford_culinary_director_of_south') }}</a></div>
	   </div>
	   
	  <div class="static-split red-line">
		  <div class="split-image">
			<img src="@/assets/images/storage_camsquares.jpg" alt="CamSquares">
		  </div>
		  <div class="split-content">
			<h2>{{ $t('storage.camsquares_freshpro') }}</h2>
			<p>{{ $t('storage.store_food_in_clear_containers_that_prom') }}</p>
			<a href="https://www.cambro.com/Products/food-storage/square-food-storage-containers/freshpro/camsquares-freshpro-food-storage-containers--camwear/" target="_blank" class="learn-more">
			<button @mouseover="isHovered = true"
					@mouseleave="isHovered = false"
					:class="{ 'hovered': isHovered }">
			  {{ $t('receiving.learn_more_btn')}}
			</button></a>
		  </div>
	   </div>
	   
	   <div class="static-testimonial">
		  <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		  <div class="testimonial-quote">{{ $t('storage.the_new_camsquares_freshpro_lids_seal_we') }}&quot;</div>
		  <div class="testimonial-pic"><img src="@/assets/images/storage_testimonial-2.jpg" /></div>
		  <div class="testimonial-name"><a href="https://blog.cambro.com/2023/11/14/what-people-really-think-about-our-camsquares-freshpro/" target="_blank">{{ $t('storage.david_hollands_executive_chef_at_the_san') }}</a></div>
	  </div>
	   
	   <div class="static-split red-line">
		   <div class="split-image">
			 <img src="@/assets/images/storage_camsquares-2.jpg" alt="CamSquares">
		   </div>
		   <div class="split-content">
			 <h2>{{ $t('storage.camsquares_freshpro_qt_and_1_qt_transluc') }}</h2>
			 <p>{{ $t('storage.these_reusable_commercial_grade_containe') }}</p>
			 <a href="https://www.cambro.com/Products/food-storage/square-food-storage-containers/freshpro/camsquares-freshpro--qt-and-1-qt--translucent/" target="_blank" class="learn-more">
			 <button @mouseover="isHovered = true"
					 @mouseleave="isHovered = false"
					 :class="{ 'hovered': isHovered }">
			   {{ $t('receiving.learn_more_btn')}}
			 </button></a>
		   </div>
		</div>
		
		<div class="static-testimonial">
		  <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		  <div class="testimonial-quote">{{ $t('storage.working_in_kitchens_for_so_long_as_i_hav') }}&quot;</div>
		  <div class="testimonial-pic"><img src="@/assets/images/storage_testimonial-3.jpg" /></div>
		  <div class="testimonial-name"><a href="https://blog.cambro.com/2023/12/13/how-to-eliminate-these-single-use-plastics-in-your-kitchen/" target="_blank">{{ $t('storage.chef_rob_rubba_owner_of_oyster_oyster')}}</a></div>
	  	</div>
		  
	   <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/storage_camwear.jpg" alt="Camwear Boxes with sliding lids">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('storage.clear_food_boxes_w_sliding_or_seal_lids') }}</h2>
		   <p>{{ $t('storage.replace_those_dusty_cardboard_boxes_with') }}</p>
		   <a href="https://www.cambro.com/Products/food-storage/food-boxes/camwear-boxes/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true"
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn')}}
		   </button></a>
		 </div>
	    </div>
	  
		<div class="static-testimonial">
		  <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		  <div class="testimonial-quote">{{ $t('storage.at_this_moment_all_our_food_boxes_are_fr') }}&quot;</div>
		  <!-- <div class="testimonial-pic"><img src="@/assets/images/storage_testimonial-3.jpg" /></div> -->
		  <div class="testimonial-name"><a href="https://blog.cambro.com/2022/04/25/restaurant-keeps-fruit-fresh-for-up-to-10-days-with-cambro-seal-covers/" target="_blank">{{ $t('storage.xuanjia_wang_coco_fresh_tea_juice_at_suz')}}</a></div>
	    </div>
		
	   <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/storage_camsquares-3.jpg" alt="CamSquares">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('storage.camsquares_allergenfree_w_seal_covers') }}</h2>
		   <p>{{ $t('storage.isolate_allergenfree_foods_from_the_big_') }}</p>
		   <a href="https://www.cambro.com/Products/food-storage/square-food-storage-containers/camsquares-classic-food-storage-containers/camsquares-allergen-free/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true"
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn')}}
		   </button></a>
		 </div>
		</div>
		
	   <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/storage_storesafe.jpg" alt="StoreSAfe Food Rotation Labels">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('storage.storesafe_food_rotation_labels')}}</h2>
		   <p>{{ $t('storage.storesafe_food_rotation_labels_description')}}</p>
		   <a href="https://www.cambro.com/Products/food-storage/storage-labels/storesafe-food-rotation-labels/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn')}}
		   </button></a>
		 </div>
		</div>
		
		<div class="sub-white">
			<h1>{{ $t('receiving.other_resources_title') }}</h1>
			<div class="home-categories">
				<a href="/storesafe/receiving" target="_parent" class="home-cat"><div class="cat-receiving"></div></a>
				<a href="#" class="home-cat dimmed"><div class="cat-storage"></div></a>
				<a href="/storesafe/preparation" target="_parent" class="home-cat"><div class="cat-prep"></div></a>
				<a href="/storesafe/service" target="_parent" class="home-cat"><div class="cat-service"></div></a>
				<a href="/storesafe/warewashing" target="_parent" class="home-cat"><div class="cat-warewashing"></div></a>
			</div>
		</div>
	  
	</div>


</template>

